import React from "react";
import { FlightDetailsModal } from "./FlightDetailsModal";
import { CalculationDebugModal } from "./CalculationDebugModal";
import { AncillariesModal, ServiceAddObj } from "./AncillariesModal";
import FarePriceDetailsModal from "./Fare.PriceDetailsModal";
import { AvailableFareModel } from "WebApiClient";
import { AssignablePassengerOption } from "components/AncillarySelection/AncillarySelection";
import FareRuleModal from "./FareRulesModal";

interface FareModalsProps {
    modals: {
        flightDetails: boolean;
        calculationDebug: boolean;
        ancillaries: boolean;
        priceDetails: boolean;
        rules: boolean;
    };
    toggleModal: (key: keyof FareModalsProps["modals"]) => void;
    FareData: AvailableFareModel;
    SelectedConnections: number[];
    SetSelectedConnection: (legindex: number, connectionIndex: number) => void;
    AddedServices: ServiceAddObj[];
    SetAddedServices: (services: ServiceAddObj[]) => void;
    AssignablePassengers: AssignablePassengerOption[];
    GetSelectedConnectionIndexByLegIndex: (legIndex: number) => number;
    setStatus: (val: boolean) => void;
}

const FareModals: React.FC<FareModalsProps> = ({
    modals,
    toggleModal,
    FareData,
    SelectedConnections,
    SetSelectedConnection,
    AddedServices,
    SetAddedServices,
    AssignablePassengers,
    GetSelectedConnectionIndexByLegIndex,
    setStatus,
}) => (
    <>
        <FareRuleModal
            IsOpen={modals.rules}
            Identifier={FareData.identifier!}
            SelectedConnections={SelectedConnections}
            SetSelectedConnection={SetSelectedConnection}
            Fare={FareData}
            Toggle={() => toggleModal("rules")}
        />

        <FlightDetailsModal
            IsOpen={modals.flightDetails}
            Identifier={FareData.identifier!}
            SelectedConnections={SelectedConnections}
            SetSelectedConnection={SetSelectedConnection}
            Fare={FareData}
            Toggle={() => toggleModal("flightDetails")}
            testConnection={GetSelectedConnectionIndexByLegIndex}
            GetSelectedConnectionIndexByLegIndex={GetSelectedConnectionIndexByLegIndex}
            setStatus={setStatus}
        />

        <CalculationDebugModal
            IsOpen={modals.calculationDebug}
            Identifier={FareData.identifier!}
            SelectedConnections={SelectedConnections}
            SetSelectedConnection={SetSelectedConnection}
            Fare={FareData}
            Toggle={() => toggleModal("calculationDebug")}
            testConnection={GetSelectedConnectionIndexByLegIndex}
            GetSelectedConnectionIndexByLegIndex={GetSelectedConnectionIndexByLegIndex}
            setStatus={setStatus}
        />

        <AncillariesModal
            IsOpen={modals.ancillaries}
            SelectedConnections={SelectedConnections}
            SetSelectedConnection={SetSelectedConnection}
            Fare={FareData}
            Toggle={() => toggleModal("ancillaries")}
            AddedServices={AddedServices}
            SetAddedServices={SetAddedServices}
            Passengers={AssignablePassengers}
        />

        <FarePriceDetailsModal
            IsOpen={modals.priceDetails}
            Toggle={() => toggleModal("priceDetails")}
        />
    </>
);

export default FareModals;
